/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {AppSharedModule} from '../../common/app-shared.module';

@Component({
  standalone: true,
  imports: [AppSharedModule],
  selector: 'adn-custom-event-type-label',
  template: `{{ ('customEvent.type.' + type) | ogTranslate }}`
})
export class CustomEventTypeLabelComponent {
  @Input() type: string;
}
